import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube, Linkedin } from "lucide-react";
import { CONTACT, NAV, SOCIALS } from "@/content/site";
import { Logo } from "@/components/Header";
import { LegalDisclaimer } from "@/components/LegalDisclaimer";
import { ContactDetails } from "@/components/ContactDetails";

const ICONS = { facebook: Facebook, instagram: Instagram, youtube: Youtube, linkedin: Linkedin };

export const SocialLinks = ({ loc }) => (
  <ul className="flex gap-2">
    {SOCIALS.map((s) => {
      const Icon = ICONS[s.id];
      return (
        <li key={s.id}>
          <a href={s.href} target="_blank" rel="noopener noreferrer" aria-label={`VidaVital Medical on ${s.label} (opens in a new tab)`} className="inline-flex h-11 w-11 items-center justify-center border border-ivory/20 text-ivory transition-colors hover:border-gold hover:text-gold" data-testid={`${loc}-social-${s.id}`}>
            <Icon aria-hidden="true" className="h-[18px] w-[18px]" />
          </a>
        </li>
      );
    })}
  </ul>
);

const FootLink = ({ to, children, id }) => (
  <li><Link to={to} className="inline-flex min-h-[44px] items-center text-stone-300 hover:text-gold" data-testid={`footer-link-${id}`}>{children}</Link></li>
);

export const Footer = () => (
  <footer className="on-dark bg-ink text-ivory" data-testid="site-footer">
    <div className="wrap grid gap-12 py-16 md:grid-cols-12">
      <div className="md:col-span-4">
        <a href={CONTACT.mainSite} target="_blank" rel="noopener noreferrer" aria-label="VidaVital Medical main website (opens in a new tab)" data-testid="footer-logo-link"><Logo /></a>
        <p className="mt-6 max-w-xs text-sm text-stone-300">A Proven, Turnkey System for Building a Concierge Wellness Clinic</p>
        <div className="mt-6"><SocialLinks loc="footer" /></div>
      </div>
      <nav aria-label="Footer" className="md:col-span-3">
        <h2 className="font-display text-xs font-semibold uppercase tracking-[0.2em] text-gold">Quick Links</h2>
        <ul className="mt-4 text-sm">
          <FootLink to="/" id="home">Overview</FootLink>
          {NAV.map((n) => <FootLink key={n.to} to={n.to} id={n.to.slice(1)}>{n.label}</FootLink>)}
          <FootLink to="/privacy-policy" id="privacy-policy">Privacy Policy</FootLink>
          <FootLink to="/terms-of-use" id="terms-of-use">Terms of Use</FootLink>
        </ul>
      </nav>
      <div className="md:col-span-5">
        <h2 className="font-display text-xs font-semibold uppercase tracking-[0.2em] text-gold">Franchise Development Contact</h2>
        <ContactDetails loc="footer" compact />
      </div>
    </div>
    <div className="wrap border-t border-ivory/15 py-10">
      <LegalDisclaimer dark />
      <div className="mt-8 flex flex-col gap-2 text-sm text-stone-300 sm:flex-row sm:items-center sm:justify-between">
        <p data-testid="footer-copyright">Copyright © 2026 VidaVital Medical. All Rights Reserved.</p>
        <ul className="flex gap-6" aria-label="Legal">
          <li><Link to="/privacy-policy" className="inline-flex min-h-[44px] items-center underline decoration-gold/60 hover:text-gold" data-testid="footer-legal-privacy">Privacy Policy</Link></li>
          <li><Link to="/terms-of-use" className="inline-flex min-h-[44px] items-center underline decoration-gold/60 hover:text-gold" data-testid="footer-legal-terms">Terms of Use</Link></li>
        </ul>
      </div>
    </div>
  </footer>
);
